import { useState, useEffect } from "react";
import "../../assets/Styles/PushNotification.css";
import { useFormik } from "formik";
import {
  SendPushNftToALl,
  GetCities,
  category,
} from "../../services/Mainservice";
import { useNavigate } from "react-router";
import { Snackbar } from "../../utils/snackbar";

const PushNotification = () => {
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  const [cities, setCities] = useState([]);
  const [categories, setCategories] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    fetchCities();
    fetchCategories();
  }, []);

  const fetchCities = async () => {
    try {
      const response = await GetCities();
      setCities(response?.data || []);

    } catch (error) {
      console.log("Cities error", error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await category("1");

      setCategories(response?.data.data || []);
    } catch (error) {
      console.log("Category error", error);
    }
  };

  const   handleClose = (event, reason, setFunction) => {
    if (reason === "clickaway") return;
    setShowError(false);
  };

  const validate = (values) => {
    const errors = {};

    if (!values.title) {
      errors.title = "Title is required";
    } else if (values.title.length > 30) {
      errors.title = "Title must be 30 characters or less";
    }

    if (!values.body) {
      errors.body = "Message is required";
    } else if (values.body.length > 100) {
      errors.body = "Message must be 100 characters or less";
    } else if (values.body.length < 2) {
      errors.body = "Message must be at least 2 characters";
    }

    return errors;
  };

const handleCategoryChange = (e) => {
  const selectedOptions = [
    ...e.target.selectedOptions,
  ].map((option) => option.value);

  if (selectedOptions.length > 3) {
    setErrorMsg("You can select a maximum of 3 categories");
    setShowError(true);
    return;
  }

  formik.setFieldValue(
    "categoryIds",
    selectedOptions
  );
};
  const handleSubmit = async (values) => {
    setLoading(true);

    try {
      const payload = {
        title: values.title,
        body: values.body,
      };

      // Optional fields
      if (values.city) {
        payload.city = values.city;
      }

      if (values.categoryIds.length > 0) {
        payload.categoryIds = values.categoryIds;
      }

      await SendPushNftToALl(payload);

      setSuccessMsg("Successfully sent push notification");
      setShowSuccess(true);
      formik.resetForm();
    } catch (error) {
      setErrorMsg(error.message || "Something went wrong");
      setShowError(true);

      if (error.code === 401) {
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      title: "",
      body: "",
      city: "",
      categoryIds: [],
    },
    validate,
    onSubmit: handleSubmit,
  });

  return (
    <div className="container1">
      <h1 className="data_heading">
        Send Push Notification
      </h1>

      <form onSubmit={formik.handleSubmit}>
        {/* Title */}
        <div className="notification_input_div">
          <label htmlFor="title" className="Auth_label">
            Title
          </label>

          <input
            type="text"
            id="title"
            name="title"
            className="notification_input"
            placeholder="Enter title.."
            onChange={formik.handleChange}
            value={formik.values.title}
          />

          {formik.errors.title && (
            <p className="invalid">
              {formik.errors.title}
            </p>
          )}
        </div>

        {/* Message */}
        <div className="notification_input_div">
          <label htmlFor="body" className="Auth_label">
            Message
          </label>

          <textarea
            id="body"
            name="body"
            className="notification_input"
            placeholder="Enter message.."
            onChange={formik.handleChange}
            value={formik.values.body}
            rows={3}
          />

          {formik.errors.body && (
            <p className="invalid">
              {formik.errors.body}
            </p>
          )}
        </div>

        {/* City Dropdown */}
        <div className="notification_input_div">
          <label className="Auth_label">
            City (Optional)
          </label>

          <select
            name="city"
            className="notification_input"
            value={formik.values.city}
            onChange={formik.handleChange}
          >
            <option value="">
              All Cities
            </option>

             {cities.data?.map((city, index) => (
              <option key={index} value={city}>
                {city}
              </option>
            ))}
          </select>
        </div>

        {/* Category Multi Select */}
        <div className="notification_input_div">
          <label className="Auth_label">
            Categories/Tags (Optional)
          </label>

          <select
            multiple
            className="notification_input"
            onChange={handleCategoryChange}
          >
            {categories?.map((category) => (
              <option
                key={category.id}
                value={category.id}
              >
                {category.Name}
              </option>
            ))}
          </select>

         
        </div>

        <button
          className="nf_button"
          type="submit"
          disabled={loading}
        >
          {loading ? "Sending..." : "Send"}
        </button>
      </form>

      <Snackbar
        open={showSuccess}
        severity="success"
        onclose={() => setShowSuccess(false)}
        message={successMsg}
      />

      <Snackbar
        open={showError}
        severity="error"
        onclose={handleClose}
        message={errorMsg}
      />
    </div>
  );
};

export default PushNotification;